function validateIfTheArraysNumberAreEqueals(arr1: Array<number>, arr2: Array<number>) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    const frecuencias1 = arr1.reduce((acc, value) => {
        acc[value] = (acc[value] || 0) + 1;
        return acc;
    }, {} as Record<string, number>);

    const frecuencias2 = arr2.reduce((acc, value) => {
        acc[value] = (acc[value] || 0) + 1;
        return acc;
    }, {} as Record<string, number>);

    for (const key in frecuencias1) {
        if (frecuencias1[key] !== frecuencias2[key]) {
            return false;
        }
    }

    return true;
}
function updateArray({ newArray, oldArray, }: { newArray: (string)[], oldArray: (string)[] }) {
    const add = newArray.filter(userId => !oldArray.includes(userId))
    const remove = oldArray.filter(userId => !!newArray.includes(userId))

    return {
        newArray: oldArray.filter(userId => !remove.includes(userId)).concat(add),
        add,
        remove
    }
}

export { validateIfTheArraysNumberAreEqueals, updateArray }